import { useCallback, useEffect, useRef, useState } from "react"
import util from "../../utils/util";
import EventBus from "../../utils/EventBus";
import addressManager from "../../manager/address";
import Block from "../../components/Base/Block";
import View from "../../components/Base/View";
import Text from "../../components/Base/Text";
import { Input } from "antd";
import tool from "../../utils/addressUtil";
import Image from "../../components/Base/Image";
import { toast } from "../../utils/toast";
import rm from "../../utils/rm";
import './edit.scss'
import RegionPicker, { RegionPickerRef } from "../../components/RegionPicker";

const AddressEdit = () => {
    const id = useRef<number>(0);
    const fromCheckout = useRef<boolean>(false)

    const [name, setName] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [region, setRegion] = useState<string[]>([]);
    const [addressDetail, setAddressDetail] = useState<string>('');
    const [ZipPostalCode, setZipPostalCode] = useState<string>('');
    const [AliasName, setAliasName] = useState<string>('');
    const [Email, setEmail] = useState<string>('');
    const [isDefault, setDefault] = useState<boolean>(false);

    const regionPickerReg = useRef<RegionPickerRef>()


    useEffect(() => {
        document.title = "修改地址";
        const onGetAddressList = (result: any) => {
            if (result.success) {
                var list = result.res.data.Content.Addresses
                var isDefault =
                    result.res.data.Content.DefaultAddressId === id.current
                var index = list.findIndex((item: any) => {
                    return item.Id === id.current
                })
                if (index !== -1) {
                    var addressObj = list[index]
                    setName(addressObj.Name)
                    setAddressDetail(addressObj.Address)
                    setPhone(addressObj.PhoneNumber);
                    setZipPostalCode(addressObj.ZipPostalCode !== 'string'
                        ? addressObj.ZipPostalCode
                        : '')
                    setAliasName(addressObj.AliasName !== 'null' ? addressObj.AliasName : '')
                    setRegion([
                        addressObj.Province,
                        addressObj.City,
                        addressObj.Area,
                        addressObj.Street,
                    ])
                    setEmail(addressObj.Email)
                    setDefault(isDefault)
                }
            }
        }
        EventBus.register(
            EventBus.names.ADDRESS_LIST_GET, onGetAddressList);

        const urlInfo = util.parasUrl(window.location.href);
        if ((urlInfo.params as any).id) {
            id.current = (urlInfo.params as any).id;
            addressManager.getAddressList();
        }
        if ((urlInfo.params as any).fromCheckout) {
            fromCheckout.current = true
        }
        document.title = id.current ? '编辑收货地址' : '添加收货地址';
        return () => {
            EventBus.unregister(
                EventBus.names.ADDRESS_LIST_GET, onGetAddressList)
        }
    }, [])


    const deleteAddress = () => {
        addressManager.deleteAddress(
            id.current,
            function (success: boolean, res: any, tips: string) {
                toast.info(tips)
                if (success) {
                    rm.closeWindow()
                }
            }
        )
    }

    const saveAddress = () => {
        if (util.isEmpty(name)) {
            toast.info('请填写收货人姓名')
            return
        }
        if (util.isEmpty(phone)) {
            toast.info('请填写收货人联系方式')
            return
        }
        if (util.isEmpty(region[0])) {
            toast.info('请选择配送地区')
            return
        }
        if (util.isEmpty(addressDetail)) {
            toast.info('请填写详细地址')
            return
        }
        var addressObj = {
            Address: {
                Name: name,
                Province: !util.isEmpty(region[0]) ? region[0] : '',
                City: !util.isEmpty(region[1]) ? region[1] : '',
                Area: !util.isEmpty(region[2]) ? region[2] : '',
                Street: !util.isEmpty(region[3]) ? region[3] : '',
                Address: addressDetail,
                ZipPostalCode: !util.isEmpty(ZipPostalCode)
                    ? ZipPostalCode
                    : '',
                PhoneNumber: phone,
                AliasName: !util.isEmpty(AliasName)
                    ? AliasName
                    : '',
                Email: Email,
                Id: id.current > 0 ? id.current : 0,
            },
            IsDefault: isDefault,
        }
        if (id.current > 0) {
            //编辑收获地址
            addressManager.updateAddress(
                addressObj,
                function (success: boolean, res: any, tips: string) {
                    toast.info(tips)
                    if (success) {
                        rm.closeWindow()
                    }
                }
            )
        } else {
            //添加收货地址
            addressManager.addAddress(addressObj,
                function (success: boolean, res: any, tips: string) {
                    toast.info(tips)
                    if (success) {
                        rm.closeWindow()
                    }
                })
        }
    }

    /**
     * 地址选择变更
     */
    const onAddressChange = useCallback((addressList: any[]) => {
        var addressArray: string[] = []
        addressList.forEach(function (item, index, attr) {
            addressArray.push(item.Name)
        })
        setRegion(addressArray)
    }, [])

    return <Block>
        <View className={'address-pannel'}>
            <View className="flex-conainer address-item">
                <Text className="flex-fix adress-left">收货人</Text>
                <Input
                    className="flex-grow"
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value)
                    }}
                    placeholder="姓名"
                ></Input>
            </View>
            <View className="flex-conainer address-item">
                <Text className="flex-fix adress-left">联系方式</Text>
                <Input
                    className="flex-grow"
                    type="number"
                    value={phone}
                    onChange={(e) => {
                        setPhone(e.target.value)
                    }}
                    placeholder="手机号码"
                ></Input>
            </View>
            <View
                className="flex-conainer address-item"
                onClick={() => {
                    regionPickerReg.current?.open(region)
                }}
            >
                <Text className="flex-fix adress-left">所在地区</Text>
                {tool.isEmpty(tool.getDisplayAddress(region)) ? (
                    <Text className="flex-grow phcolor">请选择</Text>
                ) : (
                    <Text className="flex-grow">
                        {tool.getDisplayAddress(region)}
                    </Text>
                )}
                <Image
                    className="setting-style-arrow"
                    src={require('../../images/right-arrow.png')}
                ></Image>
            </View>
            <View className="flex-conainer address-item address-item-detail">
                <Text className="flex-fix adress-left">详细地址</Text>
                <Input.TextArea
                    className="flex-grow address-detail"
                    value={addressDetail}
                    onChange={(e) => {
                        setAddressDetail(e.target.value)
                    }}
                    placeholder="街道、楼栋楼层和房间号等"
                ></Input.TextArea>
            </View>
            <View className="flex-conainer address-item">
                <Text className="flex-fix adress-left">邮箱</Text>
                <Input
                    className="flex-grow"
                    type="text"
                    value={Email}
                    onChange={(e) => {
                        setEmail(e.target.value)
                    }}
                    placeholder="电子邮箱"
                ></Input>
            </View>
            <View className="flex-conainer address-item">
                <Text className="flex-fix adress-left">邮编</Text>
                <Input
                    className="flex-grow"
                    type="number"
                    value={ZipPostalCode}
                    onChange={(e) => {
                        setZipPostalCode(e.target.value)
                    }}
                    placeholder="邮政编码"
                ></Input>
            </View>
            <View className="flex-conainer address-item">
                <Text className="flex-fix adress-left">标签</Text>
                <Input
                    className="flex-grow"
                    value={AliasName}
                    onChange={(e) => {
                        setAliasName(e.target.value)
                    }}
                    placeholder="地址别名"
                ></Input>
            </View>
            <View
                className="flex-conainer address-item"
                onClick={() => {
                    setDefault(!isDefault)
                }}
            >
                <Image
                    className="flex-fix product-radio"
                    src={
                        require('../../images/cart-' + (isDefault ? 'select' : 'unselect') + '.png')
                    }
                ></Image>
                <Text className="flex-grow">默认地址</Text>
            </View>
        </View>
        <View className={'address-btns padding-safe-area'}>
            {id.current > 0 && (
                <View
                    className="address-btn delete-btn"
                    onClick={deleteAddress}
                >
                    删除
                </View>
            )}
            {/* {fromCheckout && (
        <View
          className="address-btn import-wx-btn"
          onClick={this.importWxAddress}
        >
          导入微信地址
        </View>
      )} */}
            <View className="address-btn save-btn" onClick={saveAddress}>
                保存
            </View>
        </View>
        <RegionPicker
            ref={regionPickerReg}
            // onPannelclose={this.switchaddressPannelState}
            onAddressChanged={onAddressChange}
        ></RegionPicker>
    </Block>
}

export default AddressEdit